import React from 'react'
import { Box, Divider, Typography } from '@mui/material'

export const AmfWaiver: React.FC<{
  logoUrl: string
  highlighted?: boolean
  borderColor?: string
}> = ({ logoUrl, highlighted, borderColor }) => {
  return (
    <Box
      sx={{
        pr: 2,
        pl: 3,
        display: 'flex',
        flexFlow: 'row',
        gap: 4,
        justifyContent: 'center',
        border:
          highlighted && !!borderColor ? `1px solid ${borderColor}` : 'none',
        borderRadius: highlighted && !!borderColor ? '5px' : 'none'
      }}
    >
      <img
        src={`${logoUrl}`}
        style={{
          height: '6.5em',
          width: '10em'
        }}
      />

      <Box
        sx={{
          display: 'flex',
          flexFlow: 'column'
        }}
      >
        {highlighted ? (
          <>
            <Typography
              component="div"
              sx={{ flex: 1, mt: 2.5 }}
              fontWeight={600}
              fontSize={'.8rem'}
            >
              $60 Waived Annual Membership Fee for the first year
              <span style={{ verticalAlign: 'top', fontSize: '.5rem' }}>2</span>
            </Typography>
          </>
        ) : (
          <>
            <Typography
              component="div"
              sx={{ flex: 1, mt: 2.5 }}
              fontWeight={600}
              fontSize={'1.5rem'}
            >
              $60
            </Typography>

            <Typography
              component="div"
              variant="caption"
              style={{ lineHeight: 1.3, flex: 1 }}
            >
              Waived Annual Membership Fee for the first year
              <span style={{ verticalAlign: 'top', fontSize: '.5rem' }}>4</span>
            </Typography>

            <Divider sx={{ ml: -1 }} />
          </>
        )}
      </Box>
    </Box>
  )
}
